import styles from "./style.module.scss";
import VLProgressBar from "views/uikit/ProgressBars/VLProgressBar";
import classNames from "classnames";

export interface ProgressCardProps {
  label?: string;
  maxItems: number;
  itemLength: number;
  active?: boolean;
  onClick?: (id: string) => void;
  id: string;
}

export default function ProgressCard({
  label,
  maxItems,
  itemLength,
  active = false,
  onClick,
  id,
}: ProgressCardProps) {
  const progress = { fillPercent: (itemLength / maxItems) * 100 };
  const { fillPercent } = progress;

  return (
    <div
      className={classNames(styles.cardWrapper, {
        [styles.active]: active,
        [styles.clickable]: onClick,
      })}
    >
      <div
        className={classNames(styles.wrapper, {})}
        onClick={() => {
          onClick?.(id);
        }}
      >
        <div className={styles.headers}>
          {label && <div>{label}</div>}
          <div>
            {itemLength} / {maxItems}
          </div>
        </div>
        {fillPercent !== 0 && (
          <div>
            <VLProgressBar itemLength={itemLength} maxItems={maxItems} />
          </div>
        )}
      </div>
    </div>
  );
}
